module.exports = __webpack_public_path__ + "static/img/8.602b6d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/8.png
// module id = uHPk
// module chunks = 0